import { FC } from 'react'
import { Modal as InternalModal, ModalProps } from './modal'
import { Divider, ModalDividerProps } from './divider'

interface ModalType extends FC<ModalProps> {
  Divider: typeof Divider
}

const Modal = InternalModal as ModalType
Modal.Divider = Divider

export { Modal }
export type { ModalProps, ModalDividerProps }
